import { Button, Stack, Typography } from '@mui/material';
import { CurrentUser } from 'client/respondent/hooks';
import React from 'react';
import { LoggedInUser } from './logged-in-user';
import * as RespondentContext from 'client/respondent/core/reducers/context';
import { useRedirect } from 'client/shared/hooks';
import { RespondentActions } from 'client/respondent/core/reducers/actions';
import {
  NotLoggedInActions,
  NotLoggedInActionStatus,
} from 'client/respondent/core/types';
import { useLocation } from 'react-router';
import { ClientUrlUtils } from 'client/shared/core/helpers';

export const UserManagement: React.FC<{
  readonly respondent: CurrentUser | null;
  readonly isGuest: boolean;
}> = (p) => {
  const dispatch = RespondentContext.useRespondentDispatch();
  const redirect = useRedirect();
  const location = useLocation();
  if (!!p.respondent?.user?.respondent?.id && !p.isGuest) {
    return <LoggedInUser respondent={p.respondent} />;
  } else {
    return (
      <Stack alignItems={'center'} direction={'row'} gap={1}>
        <Button
          onClick={() => {
            dispatch(
              RespondentActions.promptRegistration({
                actionType: NotLoggedInActions.MANUAL_REGISTRATION,
                redirectLink: `${location.pathname}${location.search}`,
                data: {},
                status: NotLoggedInActionStatus.PRE_REGISTRATION,
                registrationType: null,
              })
            );
            redirect(ClientUrlUtils.respondent.signup.path(), { push: true });
          }}
        >
          Sign Up
        </Button>
        <Typography variant="body1">|</Typography>
        <Button
          onClick={() => {
            dispatch(
              RespondentActions.promptRegistration({
                actionType: NotLoggedInActions.MANUAL_REGISTRATION,
                redirectLink: `${location.pathname}${location.search}`,
                data: {},
                status: NotLoggedInActionStatus.PRE_REGISTRATION,
                registrationType: null,
              })
            );
            redirect(ClientUrlUtils.respondent.login.path(), { push: true });
          }}
        >
          Login
        </Button>
      </Stack>
    );
  }
};
UserManagement.displayName = 'UserManagement';
